import { render } from "./TfaWhatsappOptin.vue?vue&type=template&id=67d65aa2&scoped=true"
import script from "./TfaWhatsappOptin.vue?vue&type=script&lang=js"
export * from "./TfaWhatsappOptin.vue?vue&type=script&lang=js"

import "./TfaWhatsappOptin.vue?vue&type=style&index=0&id=67d65aa2&scoped=true&lang=css"

import exportComponent from "/data/vstsagent02/user/3807/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d65aa2"]])

export default __exports__